import src from "IMAGE";
export default { src, width: 481, height: 84, blurWidth: 0, blurHeight: 0};
